<template>
    <div v-if="this.enlargeClicked==true" id="enlarge-container" class="enlarge-container">
        <a @click="enlargeClicked=false,mounted = false, unselect()" class="close">X</a>
        <div v-click-outside="outsidePopup" class="selected-image ">
            <div v-if="this.currentItem!=null" :style='{backgroundImage: "url(" + getSelectedImg(this.currentItem.imgUrl) + ")"}' class="large-img">
            </div>
            <div class="col-sm-4 thumbnail-table">
                <div v-for="(image, index) in getItemUrls(this.currentItem.imgUrl) " :key="index" style="display:inline-block" >
                    <div v-if="index !==0" @click="unselect(), markSelected(image)" class="img-thumbnail" :style='{backgroundImage: "url(" + image + ")"}'>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { EventBus } from '../../eventBus'
import ClickOutside from 'vue-click-outside'

export default {
    name: "Enlarge",
    data () {
        return {
            image: null,
            enlargeClicked: false,
            mounted: false,
        }
    },
    methods: {
        outsidePopup(){
            if(this.mounted == true && this.enlargeClicked == true){
                this.enlargeClicked = false
                this.unselect()
                this.mounted = false
            }
            return 
        },
        getSelectedImg(imgUrl){
            if(this.image !==null){
                return this.image
            }
            else {
                var array = JSON.parse(imgUrl)
                return array[1]
            }
        },
        getItemUrls(urls){
            return JSON.parse(urls)
        },
        unselect(){
            this.image = null
        },
        markSelected(image){
            this.image = image
        },
    },
    beforeDestroy(){
        this.image = null
    },
    mounted(){
        EventBus.$on('enlarge', (item) => {
            this.currentItem = item;
            this.enlargeClicked = true;
             setTimeout(() => {
                this.mounted = true
            }, 1000);
        });
    },
    directives: {
        ClickOutside
    },
}
</script>
<style scoped>
.test {
    background-size: auto
}
.close {
    position: absolute;
    right: 2%;
    top: 2%;
}
.img-thumbnail {
    margin-left: 15px;
    margin-bottom: 15px;
    margin-top: 0px;
    width: 180px !important;
    height: 180px !important;
    background-position-x: center;
    background-position-y: center;
    background-color: white;
    text-align: center;
    background-repeat: no-repeat;
    background-size: contain;
}
.img-thumbnail:hover { 
    border: 1px solid white;
    box-shadow: 0px 0px 9px;
}
.thumbnail-table {
    text-align: center;
    display: inline-block !important;
    overflow: scroll;
}
@media screen and (max-width: 1000px){
   .img-thumbnail {
    width: 100px !important;
    height: 100px !important;
   }
}
@import '../../assets/css/builder.css';
</style>